var exports = {
  "Qr": "MarkdownTab.module__sectionsContainer___clFYQz",
  "uW": "MarkdownTab.module__section___clFYQz",
  "bV": "MarkdownTab.module__sectionHeader___clFYQz",
  "AS": "MarkdownTab.module__item___clFYQz",
  "Li": "MarkdownTab.module__itemHeader___clFYQz",
  "IR": "MarkdownTab.module__itemLabel___clFYQz",
};

module.exports = exports;
